import { gsap } from 'gsap/all';

const EXCLUDED_NAMESPACES = ['casestudy', 'home', 'approach'];
let headerScrollTicking = false;
let headerLastScrollY = 0;
let headerScrollListener = null;
let headerVisible = true;

function getCurrentBarbaNamespace() {
    const main = document.querySelector('main[data-barba-namespace]');
    return main ? main.getAttribute('data-barba-namespace') : null;
}

export function destroyHeaderScroll() {
    // console.log('🔴 destroyHeaderScroll called, listener exists:', !!headerScrollListener);
    if (headerScrollListener) {
        window.removeEventListener('scroll', headerScrollListener);
        headerScrollListener = null;
    }
}

export function initHeaderScroll(namespace) {
    const ns = namespace || getCurrentBarbaNamespace();
    // console.log('🟢 initHeaderScroll called, ns:', ns);
    // console.log('🟢 #header found:', !!document.querySelector('#header'));

    if (EXCLUDED_NAMESPACES.includes(ns)) {
        gsap.set('#header', { y: 0, autoAlpha: 1 });
        destroyHeaderScroll();
        return;
    }

    destroyHeaderScroll();

    const header = document.querySelector('#header');
    if (!header) {
        // console.log('❌ No #header element found, aborting');
        return;
    }

    headerLastScrollY = window.scrollY;
    headerVisible = true;
    gsap.set(header, { y: 0, autoAlpha: 1 });

    headerScrollListener = () => {
        if (headerScrollTicking) return;
        headerScrollTicking = true;

        requestAnimationFrame(() => {
            const currentScrollY = window.scrollY;
            const scrolledDown = currentScrollY > headerLastScrollY;
            const pastThreshold = currentScrollY > 100;
            const nearBottom = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 100;

            if (scrolledDown && pastThreshold && headerVisible && !nearBottom) {
                gsap.to(header, {
                    y: -(header.offsetHeight * 2),
                    opacity: 0,
                    duration: 0.4,
                    ease: 'power2.inOut'
                });
                headerVisible = false;
            } else if ((!scrolledDown || nearBottom) && !headerVisible) {
                gsap.to(header, {
                    y: 0,
                    opacity: 1,
                    duration: 0.6,
                    ease: 'power2.inOut'
                });
                headerVisible = true;
            }

            headerLastScrollY = currentScrollY;
            headerScrollTicking = false;
        });
    };

    window.addEventListener('scroll', headerScrollListener, { passive: true });
}